import React from 'react'
import styled from "styled-components"
import Joshua from './Images/Joshua.jpeg'
import Miracle from './Images/Miracle.jpeg'
import Damisi from './Images/Damisi.jpeg'
import Treasure from './Images/Treasure.jpeg'
import Bari from './Images/Bari.jpeg'
import Tobi from './Images/Tobi AOJ.jpeg'
import Pelumi from './Images/Pelumi Adesina.jpeg'
import Moses from './Images/Moses.jpeg' 
import Divine from './Images/Divine Wayne.jpeg'



function Doodles() {
    return (
        <div>
            <h1>JUST DOODLES</h1>
            <h3>OWNER: Prof </h3>
            <br/>
            <Div>
                <div><Img src={Joshua}/> Adegboye Joshua</div><br/>
                <div><Img src={Miracle}/> Miracle - </div><br/>
                <div><Img src={Damisi}/> Damisi Akinnubi</div><br/>
                <div><Img src={Treasure}/> Treasure</div><br/>
                <div><Img src={Bari}/> Bari</div><br/>
                <div><Img src={Tobi}/> Adeola Oluwatobiloba</div><br/>
                <div><Img src={Pelumi}/> Adeshina Pelumi</div><br/>
                <div><Img src={Moses}/> Moses</div><br/>
                <div><Img src={Divine}/> </div><br/>
                <div><Img src=""/> Lagoke Damola</div><br/>
                <div><Img src=""/> Grant Moses</div><br/>
                <div><Img src=""/> Ahamad</div><br/>
                <div><Img src=""/> Sodiq Samuel</div><br/>
            </Div>
    
            
        </div>
      )
}

export default Doodles

const Img = styled.img`
height: 300px;
width: 300px;
@media screen and (max-width: 750px) {
  height: 150px;
  width: 150px;
}
`

const Div = styled.div`
font-size: 20px;
font-weight: bold;
`